import { CREATIVE_ID_EDIT_AUTHENTICATED_MODAL } from 'site-modules/private-listing/constants/tracking';

export const STORAGE_KEYS = {
  LAST_COMPLETED_STEP: 'lastCompletedStep',
  IS_SUBMITTED_LISTING: 'isSubmittedListing',
  IS_UPDATED_LISTING: 'isUpdatedListing',
  SHOW_NOT_OWNER_ERROR_MSG: 'showNotOwnerError',
  VEHICLE: 'vehicle',
  TMV_DATA: 'tmvData',
};

export const INSIDER_MODAL_OPTIONS = {
  header: "Let's Save Your Progress",
  message: 'Sign up or sign in to your Edmunds account to continue creating your listing.',
  hideCloseBtn: true,
  modalProps: { backdrop: 'static', keyboard: false },
};

export const INSIDER_MODAL_OPTIONS_EDIT = {
  ...INSIDER_MODAL_OPTIONS,
  header: 'Please Sign In',
  message: 'In order to edit this listing, sign in to confirm you are the owner.',
  creativeId: CREATIVE_ID_EDIT_AUTHENTICATED_MODAL,
};

export const CREATE_LISTING_HEADER = 'Sell My Car Private Party';
export const EDIT_LISTING_HEADER = 'Edit My Listing';

export const NOT_OWNER_ERROR_MSG =
  "It doesn't seem like you're the owner of this listing. If you think this is in error, please contact support.";
